import { setTheme } from "theme/default/setTheme";

export const setColor_0083f5 = setTheme(({ theme }) => `color: ${theme.colors.color_0083f5}`);
